import '../codespaces/default-location-setting-element'
import {TemplateInstance} from '@github/template-parts'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {parseHTML} from '../parse-html'
import {remoteForm} from '@github/remote-form'

remoteForm('.js-verify-ssh-key', async function (form, wants) {
  await wants.html()

  const parent = form.closest<HTMLElement>('li')!
  parent.querySelector<HTMLElement>('.js-unverified-user-key-notice')!.remove()
  parent.querySelector<HTMLElement>('.js-user-key-icon')!.classList.remove('color-fg-danger')

  form.remove()
})

// Leave a collaborated repository
remoteForm('.js-leave-collaborated-repo', async function (form, wants) {
  await wants.html()
  const id = form.getAttribute('data-repo-id')!
  const ownerLogin = form.getAttribute('data-owner-login')!
  document.querySelector<HTMLElement>(`.js-collab-repo[data-repo-id='${id}']`)!.remove()
  if (!document.querySelector('.js-collab-repo')) {
    document.querySelector<HTMLElement>('.js-collaborated-repos-empty')!.hidden = false
    document.querySelector<HTMLElement>('.js-collaborated-repos')!.hidden = true
  }

  const ownerRepos = document.querySelector(`.js-collab-repo-owner[data-owner-login='${ownerLogin}']`)
  if (ownerRepos) {
    if (!ownerRepos.querySelector('.js-collab-repo')) {
      ownerRepos.remove()
    }
  }
})

// all other status-indicator elements.
function setIndicator(target: Element, className: string) {
  for (const statusIndicator of document.querySelectorAll('.js-setting-toggle .js-status-indicator')) {
    statusIndicator.classList.remove('status-indicator-success', 'status-indicator-loading', 'status-indicator-failed')
  }
  target.classList.add(className)
}

// Auto-subscribe checkbox toggle
remoteForm('.js-setting-toggle', async function (form, wants) {
  const target = form.querySelector<HTMLElement>('.js-status-indicator')!
  setIndicator(target, 'status-indicator-loading')
  try {
    await wants.text()
    setIndicator(target, 'status-indicator-success')
  } catch (error) {
    setIndicator(target, 'status-indicator-failed')
  }
})

on('submit', '.js-codespaces-user-settings-form', async event => {
  const form = event.currentTarget as HTMLFormElement
  event.preventDefault()
  const response = await fetch(form.action, {
    method: form.method,
    body: new FormData(form),
    headers: {Accept: 'text/fragment+html'}
  })

  // Show an error message (if request fails)
  if (response.status >= 400) {
    // eslint-disable-next-line i18n-text/no-en
    const message = 'An unknown error occurred.'
    const template = document.querySelector<HTMLTemplateElement>('template.js-flash-template')!
    template.after(new TemplateInstance(template, {className: 'flash-error', message}))
  } else {
    const target = <HTMLElement>form.closest('[data-replace-remote-form-target]')
    const partial = parseHTML(document, await response.text())
    target.replaceWith(partial)
  }
})

on('click', '.js-codespaces-user-secrets-form input[name=repo]', async event => {
  const input = (event.currentTarget as HTMLInputElement)!
  const form = input.closest<HTMLElement>('form')!
  if (!form.querySelector(`[name="codespaces_user_secret[repository_ids][]"][value="${input.value}"]`)) {
    // Create and insert the repository control
    const repoName = input.closest('.select-menu-item-text')!.querySelector('[data-menu-button-contents]')!.textContent
    if (repoName && input.value) {
      const repoControl = createRepositoryRow(repoName, input.value)
      form.querySelector('[data-target="selected-repositories.repositories"]')!.append(repoControl)
    }
    // Update the count
    updateSelectedRepositoryCount(event)
  }
  input.closest('details')!.removeAttribute('open')
  event.preventDefault()
})

on(
  'change',
  '.js-codespaces-user-secrets-form input[name="codespaces_user_secret[repository_ids][]"]',
  updateSelectedRepositoryCount
)

function createRepositoryRow(repositoryName: string, repositoryId: string) {
  const repoControl = document.createElement('li')
  repoControl.className = 'css-truncate d-flex flex-items-center width-full'
  const checkbox = document.createElement('input')
  checkbox.className = 'repository-item-checkbox js-repository-item-checkbox mx-2 position-absolute'
  checkbox.type = 'checkbox'
  checkbox.name = 'codespaces_user_secret[repository_ids][]'
  checkbox.value = repositoryId
  checkbox.id = `user-secret-repo-${repositoryId}`
  checkbox.checked = true
  repoControl.append(checkbox)
  const label = document.createElement('label')
  label.className = 'repository-item-name d-flex flex-items-center width-full color-fg-default py-1 pr-1 pl-5'
  label.setAttribute('for', `user-secret-repo-${repositoryId}`)
  label.title = repositoryName
  label.textContent = repositoryName
  repoControl.append(label)

  return repoControl
}

function updateSelectedRepositoryCount(event: Event) {
  const input = (event.currentTarget as HTMLInputElement)!
  const form = input.closest<HTMLElement>('form')!
  // Update the count
  const count = form.querySelectorAll('[name="codespaces_user_secret[repository_ids][]"]:checked').length
  form.querySelector<HTMLElement>('[data-target="selected-repositories.plural"]')!.hidden = count === 1
  form.querySelector<HTMLElement>('[data-target="selected-repositories.singular"]')!.hidden = count !== 1
  form.querySelector<HTMLElement>('[data-target="selected-repositories.count"]')!.textContent = String(count)
  form.querySelector<HTMLElement>('[data-target="selected-repositories.active-warning"]')!.hidden = count !== 0
}

// We're using this instead of a `pattern=` attribute on this input since using
// a pattern doesn't support case-insensitivity
on('focusout', '.js-codespaces-user-secrets-form input[name="codespaces_user_secret[name]"]', event => {
  const field = event.currentTarget as HTMLInputElement
  const value = field.value

  const regex = new RegExp('^(?!github).+', 'i')
  const formGroup = field.closest('div.form-group')!

  if (regex.test(value)) {
    field.setCustomValidity('')
    formGroup.classList.remove('errored')
  } else {
    // This string is never surfaced to the UI
    // eslint-disable-next-line i18n-text/no-en
    field.setCustomValidity('Secret names cannot start with "GITHUB"')
    formGroup.classList.add('errored')
  }
  const form = field.closest<HTMLFormElement>('form')!
  form.dispatchEvent(new Event('change'))
})

on('focusout', '.js-codespaces-user-secrets-form textarea[name="secret_value"]', event => {
  const field = event.currentTarget as HTMLInputElement

  const value = field.value

  const formGroup = field.closest('div.form-group')!
  if (value.trim() === '') {
    formGroup.classList.add('errored')
  } else {
    formGroup.classList.remove('errored')
  }
})
